/* Keep independent line edits through section swaps and checkout. */
(function (root) {
  'use strict';
  function create(options) {
    var entries = new Map();
    function save(key, entry) {
      clearTimeout(entry.timer);
      if (entry.promise) return entry.promise;
      entry.promise = Promise.resolve().then(function () {
        return options.save(key, entry.value);
      }).then(function () {
        if (entries.get(key) === entry) entries.delete(key);
      }).catch(function (error) {
        // Retain a failed edit. Checkout must not silently ignore or retry it.
        entry.error = error;
        throw error;
      });
      return entry.promise;
    }
    function set(key, value) {
      var previous = entries.get(key);
      if (previous) clearTimeout(previous.timer);
      var entry = { value: value };
      entries.set(key, entry);
      entry.timer = setTimeout(function () {
        save(key, entry).catch(function (error) {
          if (options.onError) options.onError(error);
        });
      }, options.delay == null ? 300 : options.delay);
    }
    async function flush() {
      // Include edits arriving while an earlier save is in flight.
      while (entries.size) {
        var batch = Array.from(entries.entries());
        var results = await Promise.allSettled(batch.map(function (pair) { return save(pair[0], pair[1]); }));
        var failed = results.find(function (result) { return result.status === 'rejected'; });
        if (failed) throw failed.reason;
      }
    }
    function restore(callback) {
      entries.forEach(function (entry, key) { callback(key, entry.value, entry.error); });
    }
    return { set: set, flush: flush, restore: restore };
  }
  root.FatheadCartPendingEdits = { create: create };
})(typeof window === 'undefined' ? globalThis : window);
